// extracted by mini-css-extract-plugin
export default {"productDescription":"N--z","featuredDescription":"O--z","description":"P--z","more":"Q--z","descriptionSku":"R--z"};